<div class="main-content">
  @if (checkingOfflineStatus) {
    <ebs-spinner class="px-3 py-1" [spinnerMessage]="'dashboard loading..'" [faColour]="'#0A3E65'" [boxColour]="'#0A3E65'"
    [boxPadding]="'5px 15px'"></ebs-spinner>
  }

  @if (!checkingOfflineStatus) {
    <div class="scrollable full-height-minus-header">
      <div class="container px-md-0">
        @if (!isDemoUser) {
          <h1 class="my-3">Welcome {{userPreferredName}}</h1>
        }
        @if (isDemoUser) {
          <h1 class="my-3">Welcome to the Edinburgh Business School Student Portal</h1>
        }
        @if (loadingHeaderFooter) {
          <ebs-spinner class="px-3 py-1" [spinnerMessage]="'loading dashboard info..'" [faColour]="'#0A3E65'"
          [boxColour]="'#0A3E65'" [boxPadding]="'5px 15px'"></ebs-spinner>
        }
        @if (!loadingHeaderFooter && !loadingCourses) {
          <div class="card dashboard-card">
            <div [innerHTML]='header'></div>
          </div>
        }
        @if (isOffline) {
          <div class="card">
            <div class="card-body">
              <p class="text-info mb-0 d-flex">
                <span class="h3 icon-gecko-offline mr-3"></span>
                Some features of your Student Portal may be unavailable offline.
              </p>
            </div>
          </div>
        }
        @if (loadingCourses) {
          <ebs-spinner class="px-3 py-1" [spinnerMessage]="'courses loading..'" [faColour]="'#0A3E65'"
          [boxColour]="'#0A3E65'" [boxPadding]="'5px 15px'"></ebs-spinner>
        }
        @if (!loadingCourses) {
          <div></div>
        }
        @if (userProfile !== undefined) {
          <h2>Courses</h2>
          <div class="card-deck" [ngClass]="{ 'card-deck-compressed': useCompressedLayout }">
            @for (courseEnrolment of courseEnrolments; track courseEnrolment) {
              @if (courseEnrolment) {
                <div class="card course-card">
                  <div class="card-body">
                    @if ((!isOffline || courseEnrolment.isDownloaded) && courseEnrolment.isLearningPlatformEnabled && courseEnrolment.studentIsRegistered) {
                      <a class="link-area"
                        [routerLink]="'/courses/' + courseEnrolment.courseCode">
                        <div class="title link" [ngClass]="{ 'h3': !useCompressedLayout }">{{courseEnrolment.courseName}}</div>
                        @if (courseEnrolment.studentIsRegistered) {
                          <div class="button">
                            <span class="btn btn-primary" role="button" aria-label="load course button">
                              <span class="icon-gecko-direction-right"></span>
                            </span>
                          </div>
                        }
                      </a>
                    }
                    @if ((!isOffline || courseEnrolment.isDownloaded) && !courseEnrolment.isLearningPlatformEnabled && courseEnrolment.studentIsRegistered) {
                      <a class="link-area"
                        [href]="courseEnrolment.fullLink">
                        <div class="title link" [ngClass]="{ 'h3': !useCompressedLayout }">{{courseEnrolment.courseName}}</div>
                        @if (courseEnrolment.studentIsRegistered) {
                          <div class="button">
                            <span class="btn btn-primary" role="button" aria-label="load course button">
                              <span class="icon-gecko-direction-right"></span>
                            </span>
                          </div>
                        }
                      </a>
                    }
                    @if ((isOffline && !courseEnrolment.isDownloaded) || !courseEnrolment.studentIsRegistered) {
                      <div>
                        <div class="title" [ngClass]="{ 'h3': !useCompressedLayout }">{{courseEnrolment.courseName}}</div>
                        @if (courseEnrolment.studentIsRegistered) {
                          <div class="button">
                            <span class="btn btn-primary disabled" role="button" aria-label="load course button disabled">
                              <span class="icon-gecko-direction-right"></span>
                            </span>
                          </div>
                        }
                      </div>
                    }
                    @if (!isOffline && !courseEnrolment.studentIsRegistered) {
                      <div class="btn-block">
                        <span class="btn {{registrationRequiredButtonClass(courseEnrolment)}} btn-min-width" role="button" aria-label="load course button"
                          (click)="registrationRequiredOpenPopup(courseEnrolment)">
                          {{registrationRequiredButtonMessage(courseEnrolment)}}
                        </span>
                      </div>
                    }
                    @if (isOffline) {
                      @if (isOffline) {
                        <div class="text mt-2 mt-sm-3">
                          @if (courseEnrolment.isLearningPlatformEnabled && !courseEnrolment.isDownloaded && !courseModuleLoading) {
                            <span
                              >
                              <span class="text-warning icon-gecko-unavailable mr-1"></span>
                              No course modules have been downloaded for offline viewing on this device.
                            </span>
                          }
                          @if (courseEnrolment.isLearningPlatformEnabled &&courseEnrolment.isDownloaded && courseEnrolment.numberOfDownloadedModules > 1) {
                            <span class="mr-1"
                              >
                              {{courseEnrolment.numberOfDownloadedModules}} modules available for offline study
                            </span>
                          }
                          @if (courseEnrolment.isLearningPlatformEnabled &&courseEnrolment.isDownloaded && courseEnrolment.numberOfDownloadedModules === 1) {
                            <span class="mr-1"
                              >
                              {{courseEnrolment.numberOfDownloadedModules}} module available for offline study
                            </span>
                          }
                          @if (isOffline && !courseEnrolment.isLearningPlatformEnabled) {
                            <span class="mr-1">
                              <span class="text-warning icon-gecko-unavailable mr-1"></span>
                              This course is not available for offline access via your student portal. Please download the
                              course
                              text via PDF or ebook format when you have internet access.
                            </span>
                          }
                        </div>
                      }
                    }
                  </div>
                  @if (doesCourseHaveTileLogoOfType(courseEnrolment.courseCode, primaryTileLogoValue) || doesCourseHaveTileLogoOfType(courseEnrolment.courseCode, secondaryTileLogoValue)) {
                    <div class="tile-logo">
                      @if (doesCourseHaveTileLogoOfType(courseEnrolment.courseCode, primaryTileLogoValue)) {
                        <span>
                          <img src="{{getTileLogo(courseEnrolment.courseCode, primaryTileLogoValue)}}" alt="{{courseEnrolment.courseName}}" />
                        </span>
                      }
                      @if (doesCourseHaveTileLogoOfType(courseEnrolment.courseCode, secondaryTileLogoValue)) {
                        <span>
                          <img src="{{getTileLogo(courseEnrolment.courseCode, secondaryTileLogoValue)}}" alt="{{courseEnrolment.courseName}}" />
                        </span>
                      }
                    </div>
                  }
                </div>
              }
            }
          </div>
          <ebs-coursera-lti [useCompressedLayout]="useCompressedLayout"></ebs-coursera-lti>
          <ebs-dashboard-menu [isWorkingOffline]="isOffline" [useCompressedLayout]="useCompressedLayout">
          </ebs-dashboard-menu>
          <div class="dashboard-footer"></div>
        }
        @if (footer && footer !='') {
          <div class="card">
            <div class="card-body">
              <div [innerHTML]='footer' class="container px-md-0"></div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>